<div class="section" (click)="onClick()">
  <div class="selector">
    <img [src]="selectedLanguage.image" />
    <p>{{ selectedLanguage.name }}</p>
  </div>
</div>
<div class="dropdown" [ngClass]="{ open: isOpen }">
  <div
    class="item"
    [ngClass]="{ selected: selectedLanguage === lang }"
    *ngFor="let lang of languages"
    (click)="onSelect(lang)"
  >
    <img [src]="lang.image" />
    <p>{{ lang.name }}</p>
  </div>
</div>
